/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function LockLaminated(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M207.96484,80h-36V52a44,44,0,0,0-88,0V80h-36a16.01833,16.01833,0,0,0-16,16V208a16.01833,16.01833,0,0,0,16,16h160a16.01833,16.01833,0,0,0,16-16V96A16.01833,16.01833,0,0,0,207.96484,80Zm-108-28a28,28,0,0,1,56,0V80h-56Zm84,140h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Zm0-32h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Zm0-32h-112a8,8,0,1,1,0-16h112a8,8,0,0,1,0,16Z" />
    </Svg>
  );
}

export default LockLaminated;
